"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const types_1 = require("./types");
const DEFAULT_CLOSE_BUTTON_COLOR = '#616161';
const CloseButton = (props) => {
    const { onClick, padding = '5px', margin = '5px', size = types_1.CloseButtonSize.Small, color = DEFAULT_CLOSE_BUTTON_COLOR, hoverEffect = types_1.CloseButtonHoverProps.Darken, autoFocus = true } = props;
    return (react_1.default.createElement(styles_1.StyledCloseButton, { autoFocus: autoFocus, margin: margin, padding: padding, color: color, size: size, hoverEffect: hoverEffect, "data-cy": 'media-carousel-modal-close-button', onClick: onClick }));
};
exports.default = CloseButton;
